import React, { useState, useEffect } from 'react'
import { Row, Col, SelectPicker } from 'rsuite'

export default function FindBudgetYear() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()

  const mockSchema = [
    { label: '2563', value: '2563' },
    { label: '2562', value: '2562' },
    { label: '2561', value: '2561' },
  ]

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    // setIsLoading(true)
    try {
      setSchema(mockSchema)
    } catch (e) {
      setError({})
    }
    // setIsLoading(false)
  }

  return (
    <>
      <Row>
        <Col xs={8} sm={8} md={8} lg={8} style={{ marginTop: 10, width: 150 }}>
          <div style={{ marginTop: 15, marginLeft: 10, width: 240 }}>
            <SelectPicker
              style={{ width: 200, boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.06)' }}
              searchable={false}
              data={schema}
              placeholder="ปีงบประมาณ"
            />
          </div>
        </Col>
      </Row>
    </>
  )
}
